import { Link } from 'react-router-dom';
import { Wordmark } from './Wordmark.jsx';
import { ThemeToggle } from './ThemeToggle.jsx';

export function MiniHeader() {
  return (
    <header className="mini-header">
      <Link to="/" className="nav__brand"><Wordmark height={22} /></Link>
      <ThemeToggle />
      <Link to="/studies" className="btn btn--aqua nav__cta">All studies</Link>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container site-footer__in">
        <div className="site-footer__brand">
          <Wordmark height={22} light />
          <p>Measure knowledge. Assess attitudes. Improve practice.</p>
        </div>
        <nav className="site-footer__links">
          <Link to="/studies">Studies</Link>
          <a href="#how">How it works</a>
          <a href="#features">Features</a>
          <a href="#faq">FAQ</a>
        </nav>
      </div>
      <div className="container site-footer__legal">
        © 2026 KAPstat. A research platform operated by Eddlynn Edtech Private Limited (CIN U63119TN2026PTC191576).
        Anonymous &amp; secure. For research use — study instruments are starter drafts pending expert content validation.
      </div>
    </footer>
  );
}
